import React from "react";
import { useConfig } from "../../contexts/ConfigContext";
import { useLanguage } from "../../contexts/LanguageContext";
import ModelItem from "./ModelItem";

const ModelList: React.FC = () => {
  const { getFilteredModels } = useConfig();
  const { t } = useLanguage();

  const models = getFilteredModels();

  if (models.length === 0) {
    return <div className="no-models">{t("no_models_selected")}</div>;
  }

  return (
    <div className="model-list">
      {models.map((model, index) => {
        // Создаем отображаемое имя модели
        let displayName = model.name;

        if (model.type !== "other") {
          // Подсчитываем количество моделей того же типа
          const sameTypeModels = models.filter((m) => m.type === model.type);
          if (sameTypeModels.length > 1) {
            const indexInType = sameTypeModels.findIndex(
              (m) => m.id === model.id
            );
            displayName = `${t(model.type)} #${indexInType + 1}`;
          } else {
            displayName = t(model.type);
          }
        }

        return (
          <ModelItem key={model.id} model={model} displayName={displayName} />
        );
      })}
    </div>
  );
};

export default ModelList;
